exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../css-loader/index.js!./widget.css"), "");
exports.i(require("-!../../../css-loader/index.js!./accordionpanel.css"), "");
exports.i(require("-!../../../css-loader/index.js!./commandpalette.css"), "");
exports.i(require("-!../../../css-loader/index.js!./dockpanel.css"), "");
exports.i(require("-!../../../css-loader/index.js!./menu.css"), "");
exports.i(require("-!../../../css-loader/index.js!./menubar.css"), "");
exports.i(require("-!../../../css-loader/index.js!./scrollbar.css"), "");
exports.i(require("-!../../../css-loader/index.js!./splitpanel.css"), "");
exports.i(require("-!../../../css-loader/index.js!./tabbar.css"), "");
exports.i(require("-!../../../css-loader/index.js!./tabpanel.css"), "");

// module
exports.push([module.id, "/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Copyright (c) 2014-2017, PhosphorJS Contributors\n|\n| Distributed under the terms of the BSD 3-Clause License.\n|\n| The full license is in the file LICENSE, distributed with this software.\n|----------------------------------------------------------------------------*/\n", ""]);

// exports
